import { useTheme } from "@mui/material/styles";
import type { AppCustomStyles } from "./types";

export function useAppCustomStyles(): AppCustomStyles {
  return useTheme().custom;
}
